import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";
import { S } from "../../data/strings";
import { ITTAR, waLink, WA } from "../../data/content";
import { SectionHead } from "./Ornament";
import { WhatsappIcon } from "./Header";
import { EASE } from "../../lib/motion";

export const ArtOfIttar = () => {
  const { t } = useLang();
  return (
    <section id="ittar" data-testid="ittar-section" className="relative bg-ivory grain py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <SectionHead overline={S.ittar.overline} heading={S.ittar.heading} sub={S.ittar.sub} />

        <div className="mt-16 grid grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-7">
          {ITTAR.map((p, i) => (
            <motion.article
              key={p.id}
              data-testid={`ittar-card-${p.id}`}
              className="group flex flex-col bg-white/70 border border-linen hover:border-gold/50 rounded-lg overflow-hidden transition-all duration-500 hover:shadow-[0_18px_50px_rgba(61,12,26,0.1)] hover:-translate-y-1"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.7, ease: EASE, delay: (i % 3) * 0.08 }}
            >
              <div className="relative overflow-hidden aspect-[4/5] bg-cream">
                <img
                  src={p.img}
                  alt={`${t(p.name)} — traditional Indian attar`}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 bg-ivory/90 backdrop-blur px-2.5 py-1 rounded-full font-cinzel text-[9px] tracking-widest uppercase text-gold">
                  {t(p.notes)}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-4 sm:p-5">
                <h3 className="font-serif text-lg sm:text-xl text-maroon leading-tight">{t(p.name)}</h3>
                <p className="mt-1.5 text-maroon/60 text-xs sm:text-sm leading-relaxed line-clamp-2 flex-1">{t(p.desc)}</p>
                <div className="mt-4 flex items-center justify-end gap-2">
                  <a
                    href={waLink(WA.ittar(p.name.en))}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`ittar-enquire-${p.id}`}
                    className="inline-flex items-center gap-1.5 rounded-full bg-maroon px-3.5 py-2 text-[11px] sm:text-xs font-medium text-ivory hover:bg-wine transition-colors duration-300"
                  >
                    <WhatsappIcon className="w-3 h-3" />
                    {t(S.enquireWa)}
                  </a>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
